import { Injectable } from '@angular/core';
import { Http, Response, Headers, ResponseContentType } from '@angular/http';
import { IErCoverageWorkDetail } from './erCoverageWorkDetail';
import { Observable } from 'rxjs/Observable';
import { CONFIGURATION } from '../app.config';


@Injectable()
export class ErCoverageReportService {

    // private _erCoverageReportUrl = 'app/api/';
    private _erCoverageReportUrl = CONFIGURATION.baseServiceUrl + 'ercoveragereportservice/';
    private _ssnUrl = CONFIGURATION.baseServiceUrl + 'SsnInfo/';

    constructor(private _http: Http) { }

    getCoverageByYear(filterCriteria: any): Observable<any> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');

        let fileName: string = 'getERCoverageFTECountByWorkMonth?WorkMonth=' + filterCriteria.selectedYear
            + '&ControlGroup=' + filterCriteria.selectedControlGroup
            + '';
        return this._http.get(this._erCoverageReportUrl + fileName, { headers: headers })
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }

    getReportData(): Observable<any> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.get(this._erCoverageReportUrl + 'getERCoverageReportReferenceData', { headers: headers })
            .map((response: Response) => response.json().erCoverageReferanceDataVO)
            .catch(this.handleError);
    }

    getSSnData(ssnData: any): Observable<any> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        let fileName = 'ssnreportdata?Ssn=' + ssnData.ssn
            + '&TaxYear=' + ssnData.taxyear
            + '&ControlGroup=' + ssnData.controlgroup
            + '&ReportName=' + 'ERCoverageReport';
        return this._http.get(this._ssnUrl + fileName, { headers: headers })
            .map((response: Response) => response.json().reportsByAnnualizedMonthlyCountVO)
            .catch(this.handleError);
    }

    getAnnulaizedMonthlyWorkers(filterCriteria: any): Observable<any> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        let fileName: string = 'getERCoverageReportCountByWeek?WorkYear=' + filterCriteria.selectedYear
            + '&ControlGroup=' + filterCriteria.selectedControlGroup;
        return this._http.get(this._erCoverageReportUrl + fileName, { headers: headers })
            .map((response: Response) => response.json().annualizedMonthlyCountVO)
            .catch(this.handleError);

        //  return { annulaizedMonthly: "26" };
    }

    getAnnulaizedMonthlyWorkersReportData(filterCriteria: any): Observable<IErCoverageWorkDetail[]> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        let fileName = 'getERCoverageReportData?WorkYear=' + filterCriteria.selectedYear
            + '&ControlGroup=' + filterCriteria.selectedControlGroup
            + '';
        return this._http.get(this._erCoverageReportUrl + fileName, { headers: headers })
            .map((response: Response) => <IErCoverageWorkDetail[]>response.json().reportsByAnnualizedMonthlyCountVO)
            .catch(this.handleError);
    }

    downloadExcelReport(filterCriteria: any): any {
        let fileName = 'processERCoverageReportExcelUpload?WorkYear=' + filterCriteria.selectedYear
            + '&ControlGroup=' + filterCriteria.selectedControlGroup
            + '';

        //window.open(this._erCoverageReportUrl + fileName, '_bank');
        const url = this._erCoverageReportUrl + fileName
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.get(url, { headers: headers, responseType: ResponseContentType.Blob }).map(
            (res) => {
                const a = document.createElement('a');
                document.body.appendChild(a);
                const blob = new Blob([res.blob()], { type: 'application/zip' });
                const downloadUrl = URL.createObjectURL(blob);
                window.open(downloadUrl);
            })
    }

    downloadPDFReport(filterCriteria: any): any {
        let fileName = 'processERCoverageReportPDFUpload?WorkYear=' + filterCriteria.selectedYear
            + '&ControlGroup=' + filterCriteria.selectedControlGroup
            + '';
        //window.open(this._erCoverageReportUrl + fileName, '_bank');
        const url = this._erCoverageReportUrl + fileName
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        // headers.append('Authorization', 'JWT ' + localStorage.getItem('id_token'));
        return this._http.get(url, { headers: headers, responseType: ResponseContentType.Blob }).map(
            (res) => {
                var link = document.createElement('a');
                let blob = new Blob([res.blob()], {
                  type: 'application/pdf' // must match the Accept type
                });
                link.href = window.URL.createObjectURL(blob);
                link.download = `${filterCriteria.selectedYear}_${filterCriteria.selectedControlGroup}_${Date.now()}.pdf`;
                link.click();
                window.URL.revokeObjectURL(link.href);
            })
    }
    private handleError(error: Response) {
        // in a real world app, we may send the server to some remote logging infrastructure
        // instead of just logging it to the console
        console.error(error);
        return Observable.throw(error.json().error || 'Failed in web api(Server error) ');
    }

}



// WEBPACK FOOTER //
// ./src/app/ErCoverageReport/erCoverageReport.service.ts